'use client'
import ArrowCircle from '@/components/Atoms/ArrowCircle'
import Cursor from '@/components/Atoms/Cursor'
import TalkCard from '@/components/Molecules/TalkCard'
import { useCursor } from '@/hooks/useCursor'
import { useWindowSize } from '@/hooks/useWindowSize'
import Link from 'next/link'
import { useSuspenseQuery } from '@apollo/experimental-nextjs-app-support/ssr'
import { gql } from '@apollo/client'
import { PostNewsProps, PageInfo } from '@/types'
import LottieAnimation from '@/components/Atoms/LottieAnimation'
import { useState } from 'react'
import Pagination from '@/components/Atoms/Pagination'
export default function InterViewAllSession({ slug }: { slug: number }) {
  const [page, setPage] = useState(slug)
  const limit = 9

  const query = gql`
    query GetInformationByCategory {
      getInformationByCategorySlug(
        categorySlug: ["recruit"]
        page: ${page}
        limit: ${limit}
      ) {
        collection {
          id
          title
          imageFileName
          slug
          count
          createdAt
          updatedAt
          categories {
            id
            name
            slug
          }
          informationTags {
            id
            name
            slug
          }
          informationMeta {
            id
            name
            title
          }
          informationInformationMeta {
            informationMetumId
            value
          }
        }
        pageInfo{
          currentPage
          hasNextPage
          hasPreviousPage
          isFirstPage
          isLastPage
          totalPages
        }
      }
    }
  `

  const { data } = useSuspenseQuery<{
    getInformationByCategorySlug: {
      collection: PostNewsProps[]
      pageInfo: PageInfo
    }
  }>(query)
  const informations = data.getInformationByCategorySlug.collection
  const { pageInfo } = data.getInformationByCategorySlug
  const { width } = useWindowSize()
  const { mouseProperties, setMouseProperties, mouseDisplay, setMouseDisplay } =
    useCursor()

  return (
    <div className="relative ">
      <div className="absolute -top-9 -right-40 md:top-[15px] md:-right-[160px]">
        <div className="w-[220px] md:w-[240px] h-auto">
          <LottieAnimation src={'/lottie/Arrow.lottie'} />
        </div>
      </div>

      <div className="md:flex md:flex-wrap md:[&>*]:w-[calc((100%_-_64px)_/_3)] md:[&>*]:mr-8 md:[&>*]:mb-16 md:[&>*:nth-child(3n+3)]:mr-0 md:pt-[120px] block pt-16 pb-8 md:pb-0 [&>*]:mb-8 [&>*:last]:mb-0 md:mb-10">
        {informations.map((item) => (
          <div className="" key={item.title}>
            <TalkCard
              title={item.title}
              categories={item.categories}
              tags={item.informationTags}
              images={
                process.env.NEXT_PUBLIC_AWS_S3_URL +
                '/' +
                item.id +
                '/original_' +
                item.imageFileName
              }
              href={'/interview/' + item.slug}
              size="sm"
              onEnter={() => {
                setMouseProperties({
                  text: ' CLICK',
                  color: '#ffffff',
                  background: '#242A32',
                })
                setMouseDisplay(true)
              }}
              onLeave={() => setMouseDisplay(false)}
            />
          </div>
        ))}
      </div>
      <Pagination pageInfo={pageInfo} setPage={setPage} />
      {width > 768 && (
        <Cursor
          textMouse={mouseProperties.text}
          textColor={mouseProperties.color}
          background={mouseProperties.background}
          display={mouseDisplay}
          mixblendMode="mix-blend-hard-light"
        />
      )}
      <div className="text-center md:mt-20 mt-14">
        <Link
          href={'/interview'}
          className="flex items-center justify-center group"
        >
          <span className="font-notosans_jp font-bold text-[14px] md:text-[16px] leading-none mr-3 whitespace-nowrap group-hover:text-blue_400 transition-colors duration-300">
            インタビューTOPへ
          </span>
          <ArrowCircle size="lg" direction="left" />
        </Link>
      </div>
    </div>
  )
}
